import { Measurement } from "../models/measurement";
import { ShipmentTrackingToExport } from "../models/shipment.tracking";
import { calculateAndConvertOrdersVolume } from "./calculateAndConvertOrdersVolume";
import { jsonToCsv } from "./generateCsv";

export const exportCSV = (
  data: ShipmentTrackingToExport[],
  measurement: Measurement,
  companyName?: string,
  callback?: () => void
) => {
  const filename = `shipments-${companyName?.trim().toLowerCase()}-${new Date().toISOString()}`;
  const extension = "csv";
  const fileNameWithExtension = `${filename}.${extension}`;

  const json = data.map((item) => {
    const { jobs, ...rest } = item;

    if (jobs?.length) {
      const volumes = calculateAndConvertOrdersVolume(measurement, jobs);
      const newItem = {
        ...rest,
        orders: jobs?.map((job: any) => job.reference)?.join(", "),
        [`volume (${measurement.code})`]: volumes,
      };

      return newItem;
    }

    return { ...rest };
  });

  const jsonString = `data:text/csv;chatset=utf-8,${encodeURIComponent(jsonToCsv(json))}`;
  const link = document.createElement("a");

  link.href = jsonString;
  link.download = fileNameWithExtension;
  document.body.appendChild(link);

  link.click();
  link.remove();

  if (callback) callback();
};
